// ГЕЙТ ТРЁХ ЭТАПОВ, СЧЁТНАЯ МИКРОКОПИ И ШИТ-НУДЖ — арифметика B4-4
// `3e419875cbb881abb94bdf344ee1d2c5`.
//
// ИСТОЧНИК — `<script>` борда `Life Map - s2 Stage Gate v6.html` (байты v5 плюс слой раскладки):
// `cta()` (три ветки), счётная
// половина `micro()` (три ветки) и условие нуджа из обработчика `$('cta').onclick`
// (`S.n<DEEP&&!S.spent`). Каждая строка сверяется с байтом борда машинно —
// `src/render/__parity__/wizard-s2-copy.test.jsx`.
//
// ПОЧЕМУ ОТДЕЛЬНЫЙ МОДУЛЬ, А НЕ ТЕЛО КОМПОНЕНТА — та же причина, что у `stageList.js` и
// `stageDraft.js`: здесь утверждения о СОСТОЯНИИ (открыт ли гейт, что он говорит, пора ли
// спрашивать), и проверять их надо без монтирования. Плюс своя причина: гейт печатает не экран,
// а ОБОЛОЧКА (кнопка `continue` живёт в `footerNav.js`), и функция, которую зовут двое, не имеет
// права быть замыканием одного из них.
//
// ⚠️ ФЛАГ ПОГАШЕННОГО НУДЖА ЖИВЁТ В ПАМЯТИ ВКЛАДКИ, А НЕ В КОНВЕРТЕ (`s895.d3`). Отсюда
// модульная переменная: перезагрузка обнуляет её вместе с модулем, и нудж при 3–4 этапах может
// показаться снова — ровно как говорит решение («на сессию» = до перезагрузки вкладки). Конверт
// `s864.d1` заморожен, и правка его формы ради одного флага означала бы подъём `schemaVersion`.

import { STAGE_DEEP, STAGE_FLOOR } from './stageList.js';

export { STAGE_DEEP, STAGE_FLOOR };

/** Сколько тост перехода держится на экране (борд: `setTimeout(…,1600)` в `$('cta').onclick`). */
export const TOAST_MS = 1600;

/**
 * Сколько кнопки шита-нуджа не принимают тап после появления шита (ответ CD 1а, 29.09, B4-v6).
 *
 * ⚠️ ЧИСЛО НЕ НАШЕ И НЕ ПРОИЗВОЛЬНОЕ. Кнопка шита встаёт ровно в точку CTA (замер cc-136), и
 * второй тап быстрого двойного попадает в неё раньше, чем человек прочитал вопрос. CD выбрал
 * не разводить геометрию, а дать окно длиной в ВЫЕЗД ШИТА: `.sheet{transition:transform .3s}`
 * (`Stage Gate v5.html:136`, в v6 то же правило) — пока шит едет, тапать ещё не по чему.
 */
export const NUDGE_ARM_MS = 300;

/**
 * Состояние гейта: `null` — открыт, иначе объявление, что печатает кнопка оболочки.
 *
 * `lead`/`trail` — половинки надписи вокруг числа: у борда число стоит отдельным узлом
 * (`<span class="n">`), и красится оно отдельно (`.cta.off .n{color:var(--amber)}`). Отдавать
 * оболочке одну склеенную строку значило бы потерять единственное, что в этой надписи громкое.
 *
 * ⚠️ НАДПИСЬ ОТКРЫТОГО СОСТОЯНИЯ ЗДЕСЬ НЕ ЖИВЁТ, И ЭТО НЕ ПРОПУСК. Пока гейт открыт, надпись
 * берёт таблица оболочки (`footerNav.js`): это её предмет на всех шести шагах, и второй
 * источник тут завёлся бы ровно на одном.
 * ⭐ РЕГИСТР БОЛЬШЕ НЕ РАСХОДИТСЯ. Здесь стояло «борд печатает `Continue`, таблица — `continue`»;
 * CD назвал каноном строчные (ответ 1б, 29.09), и `Stage Gate v6` печатает `continue` и в
 * разметке, и в ветке скрипта. Совпадение пришпилено копи-парити.
 *
 * @param {Array} rows сохранённые ряды
 * @param {object|null} draft открытый черновик
 * @returns {null|{kind: string, label: string, count: number|null, lead: string|null, trail: string|null}}
 */
export function ctaGate(rows, draft) {
  // Порядок веток — борда: черновик сильнее счёта. На двух этапах с открытым черновиком человеку
  // сначала говорят «доделай ряд», а не «добавь ещё один», — иначе совет зовёт туда, где уже стоят.
  if (draft) return { kind: 'draft', label: 'finish this stage first', count: null, lead: null, trail: null };

  const left = STAGE_FLOOR - rows.length;
  if (left > 0) {
    // `&nbsp;` борда — неразрывные пробелы вокруг числа (U+00A0), а не обычные: число с обеих
    // сторон приклеено к словам, чтобы перенос не оставил его одно в строке.
    return {
      kind: 'need',
      label: `add ${left} more to continue`,
      count: left,
      lead: 'add ',
      trail: ' more to continue',
    };
  }
  return null;
}

/**
 * Числа словами до десяти включительно (`s675.d1`, карта `NUMW`).
 *
 * ⚠️ ЧЕТВЁРТАЯ КОПИЯ ЭТОЙ КАРТЫ В РЕПО — она же лежит в `SectionIV/V/VI/VII.jsx`. Общий хелпер
 * сюда не тащу: секции паспорта — байт-парити зона, и вынос карты из них тронул бы четыре
 * запиненных файла ради одного нового вызова. Долг назван (тот же класс, что общий римский
 * хелпер из замера cc-135) и живёт одной строкой, а не молча.
 *
 * Потолок ряда — 15 этапов, то есть 11…15 печатаются цифрой по построению карты, как в секциях.
 */
const NUMW = {
  1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five',
  6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten',
};

/** Число словом до десяти, дальше цифрой (`s675.d1`). */
const word = (n) => NUMW[n] || String(n);

/**
 * Строка над Continue (борд: `micro()`).
 *
 * Шесть веток в одном месте, потому что у борда они в одной функции и читаются как одна лестница:
 * черновик перебивает счёт целиком, и только под ним идёт счётная половина.
 *
 * `bold` — то, что у борда в `<b>`; `rest` — хвост в `.slot` (пунктир доски не портируется, см.
 * `EmptyStack` в `StepTwo.jsx`). У черновиковых веток хвоста нет вовсе: там жирное всё.
 *
 * ⭐ СЧЁТНАЯ ПОЛОВИНА НЕСЁТ КОПИ РЕШЕНИЯ (`s904.d1`), А НЕ БАЙТ БОРДА. Ветки, их число и место
 * жирного — борда; текст — из банка. «read» из строк ушло: на шаге 2 человек знает только слова
 * шага 1 (`Life Map`, `a 7-page map of your life`, `stage`, `find what was hiding`), а `map` и
 * `reading` как термины продукта ему ещё не представлены. Порог пяти теперь говорится прямо.
 * Число — словом (`s675.d1`).
 *
 * @param {Array} rows
 * @param {object|null} draft
 * @param {boolean} gridOpen раскрыта ли сетка месяцев
 * @returns {null|{bold: string, rest: string|null, deep: boolean}}
 */
export function microLine(rows, draft, gridOpen) {
  if (draft) {
    if (!draft.name) return { bold: 'name it first', rest: null, deep: false };
    // `s826.d1`: пока контрол открыт, подсказки над Continue нет — вопрос уже задан над сеткой,
    // и второй раз его задавать незачем. Единственное состояние, где строки нет вовсе.
    if (!draft.start) return gridOpen ? null : { bold: 'when did it start?', rest: null, deep: false };
    return { bold: 'tap ✓ to save it', rest: null, deep: false };
  }

  const n = rows.length;
  if (n < STAGE_FLOOR) return { bold: 'three stages and your map can start', rest: null, deep: false };
  if (n < STAGE_DEEP) {
    return { bold: `${word(n)} stages`, rest: ' · enough to start · five is much better', deep: false };
  }
  return { bold: `${word(n)} stages`, rest: ' · plenty to work with', deep: true };
}

/**
 * Копи шит-нуджа — пять ключей банка шага 2 (`s2.nudge.ttl` · `.body` · `.more` · `.add` · `.go`),
 * строки из `s904.d1`.
 *
 * ⭐ ЭТО КОПИ РЕШЕНИЯ, А НЕ ПОРТ БАЙТА. У борда все четыре строки шита — `.slot`, то есть
 * плейсхолдеры Voice, и две из них считали вслух только под три этапа: на четырёх кнопка звала
 * «continue with 3», а абзац обещал «ещё два». Банк закрыл долг с честным счётом по N, поэтому
 * функция живёт здесь, рядом с остальной арифметикой гейта, и проверяется без монтирования.
 *
 * ⚠️ Счёт идёт от `STAGE_DEEP`, а не от литерала: «сколько ещё до пяти». Порог один и тот же у
 * `nudgeDue`, у ветки `micro()` и здесь — разъехаться они не имеют права.
 *
 * `add` — единственная строка, совпадающая с байтом борда дословно; остальные четыре расходятся,
 * и это расхождение названо в `WIZARD-CANON.md` и пришпилено копи-парити.
 *
 * @param {number} n сохранённых этапов (зовётся только когда `nudgeDue(n)`)
 */
export function nudgeCopy(n) {
  const left = STAGE_DEEP - n;
  const more = word(left);
  return {
    ttl: 'before we build your map',
    body: 'Three stages is the minimum. Five is much better. Six or more is best.',
    // Заглавная буква — начало предложения, а не часть числа: карта `NUMW` строчная везде.
    more: `${more[0].toUpperCase()}${more.slice(1)} more would help.`,
    add: 'add one more',
    go: `continue with ${word(n)} →`,
  };
}

/**
 * Пора ли спрашивать нуджем (борд: `S.n<DEEP&&!S.spent` при открытом гейте).
 *
 * Нижняя граница у борда не написана — она следует из порядка веток: до пола управление до
 * нуджа не доходит вовсе. Здесь она названа явно: функцию зовут не из той же лестницы.
 */
export function nudgeDue(n) {
  return n >= STAGE_FLOOR && n < STAGE_DEEP;
}

// ⚠️ ПАМЯТЬ ВКЛАДКИ — МОДУЛЬНАЯ ПЕРЕМЕННАЯ, И ЭТО РОВНО ТО, ЧТО ПРОСИТ `s895.d3`. Она переживает
// перемонтирование экрана (человек ушёл на шаг 3 и вернулся назад — нудж не повторяется) и не
// переживает перезагрузку (модуль поднимается заново). Конверта она не касается.
let spent = false;

/** Погашен ли нудж в этой вкладке. */
export function nudgeSpent() {
  return spent;
}

/** `continue with 3 →` — гасит нудж до перезагрузки вкладки (`s895.d3`). */
export function spendNudge() {
  spent = true;
}

/**
 * Сброс флага. Нужен ТЕСТАМ: модульная переменная переживает `cleanup()` и утекла бы из теста в
 * тест — второй сценарий нуджа зеленел бы тавтологией «шита нет, потому что его погасил первый».
 * В продукте не зовётся ниоткуда: там флаг снимает только перезагрузка.
 */
export function resetNudge() {
  spent = false;
}
